"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.structDefEq = void 0;
var typeExtends_1 = require("../../type_system/typeExtends.js");
function structCtorEq(a, b) {
    if (a === b)
        return true; // shallow eqality;
    var aFieldsNames = Object.keys(a);
    var bFieldsNames = Object.keys(b);
    if (aFieldsNames.length !== bFieldsNames.length)
        return false;
    for (var i = 0; i < aFieldsNames.length; i++) {
        if (aFieldsNames[i] !== bFieldsNames[i])
            return false;
        var thisAField = a[aFieldsNames[i]];
        var thisBField = b[bFieldsNames[i]];
        if (!((0, typeExtends_1.typeExtends)(thisAField, thisBField) &&
            (0, typeExtends_1.typeExtends)(thisBField, thisAField)))
            return false;
    }
    return true;
}
function structDefEq(a, b) {
    if (a === b)
        return true; // shallow eqality;
    var aCtors = Object.keys(a);
    var bCtors = Object.keys(b);
    if (aCtors.length !== bCtors.length)
        return false;
    for (var i = 0; i < aCtors.length; i++) {
        if (aCtors[i] !== bCtors[i])
            return false;
        if (!structCtorEq(a[aCtors[i]], b[bCtors[i]]))
            return false;
    }
    return true;
}
exports.structDefEq = structDefEq;
